import React from 'react'

import {
  string, array, arrayOf, shape,
} from 'prop-types'

import i18n from 'Pods/Shared/I18nHome'
import { printModelsPath } from 'Pods/Shared/paths'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import AssetCollection from './Components/AssetCollection'

function PrintReadyModels({ locale = 'en', itemCategories = EMPTY_ARRAY, trending = EMPTY_ARRAY }) {
  const title = i18n.t('printReadyModels.title', {
    ns: 'new-home',
    lng: locale,
  })
  const description = i18n.t('printReadyModels.description', {
    ns: 'new-home',
    lng: locale,
  })
  const browseButton = i18n.t('printReadyModels.browseButton', {
    ns: 'new-home',
    lng: locale,
  })

  const allCategoriesText = i18n.t('assetCategory.allCategories', {
    ns: 'new-home',
    lng: locale,
  })

  const browseAllButtonPath = printModelsPath(locale, { page: '1' })

  return (
    <div className="print-ready-models">
      <AssetCollection
        id="print-ready-models"
        title={title}
        description={description}
        trendingButtons={trending}
        items={itemCategories}
        browseAllHref={browseAllButtonPath}
        browseAllText={browseButton}
        collectionType="print-models-3d"
        allCategoriesText={allCategoriesText}
        locale={locale}
      />
    </div>
  )
}

PrintReadyModels.propTypes = {
  locale: string,
  itemCategories: array,
  trending: arrayOf(shape({
    name: string,
    url: string,
  })),
}

PrintReadyModels.displayName = 'PrintReadyModels'

export default PrintReadyModels
